/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Container,
	Box,
	Flex,
	Text,
	Center,
	Checkbox,
	Badge,
	Tooltip,
	Button,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	useDisclosure,
	SimpleGrid,
} from '@chakra-ui/react';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import { faSlidersH, faPrint, faChartLine, faFileExcel, faPlus, faRetweet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useLazyQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import { useLocation, useHistory } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import ReactPaginate from 'react-paginate';
import CompanySubmissionProposalFilter from '../../components/Filter/CompanySubmissionProposalFilter';
import LoadingResponsiveTable from '../../components/Table/LoadingResponsive';
import datePickerFromToToDate from '../../utils/datePickerFromToToDate';
import PrintLayout from '../../components/Print/PrintLayout';
import ExcelExportModal from '../../components/Modal/ExcelExportModal';
import ProposalDetailModal from './detailModal';
import LoadingOverlayText from '../../components/LoadingOverlay/LoadingOverlayText';
import ProposalReassignModal from '../../components/Modal/ProposalReassignModal';
import moment from 'moment';
import useStore from '../../store';
import c from '../../constant';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './style.css';

const QUERY_PROPOSALS = gql`
	query getCompanySubmissionProposals(
		$limit: Float
		$offset: Float
		$fromDate: DateTime
		$toDate: DateTime
		$read: Boolean
		$number: Float
		$companyName: String
		$subject: String
		$department: String
		$office: String
		$status: String
		$publicService: Boolean
		$spam: Boolean
		$showNearlyDue: Boolean
		$state: String
		$showIncomplete: Boolean
		$auditServiceOnly: Boolean
	) {
		getCompanySubmissionProposals(
			pagerInput: { limit: $limit, offset: $offset }
			fromDate: $fromDate
			toDate: $toDate
			read: $read
			number: $number
			companyName: $companyName
			subject: $subject
			department: $department
			office: $office
			status: $status
			publicService: $publicService
			spam: $spam
			showNearlyDue: $showNearlyDue
			state: $state
			showIncomplete: $showIncomplete
			auditServiceOnly: $auditServiceOnly
		) {
			companySubmissionProposals {
				id
				no
				companyName
				subject
				createdAt
				read
				assignTo {
					read
					user {
						id
					}
				}
				approved
				approvedAt
				dueDate
				publicService
				spam
				company {
					id
					name
					nameKhmer
					logo
				}
				done
				doneAt
				submissionStatus
				startServiceDate
				assignedDepartment {
					id
				}
				assignedOffice {
					id
				}
			}
			countUnreadCompanySubmissionProposals
			totalPages
			totalRows
		}
	}
`;

const QUERY_ALL_PUBLIC_SERVICES = gql`
	query {
		getAllPublicServices {
			id
			value
			title
			active
		}
	}
`;

function Proposal({ auditServiceOnly = false }) {
	const { t } = useTranslation();
	const location = useLocation();
	const history = useHistory();
	const urlParams = new URLSearchParams(location.search);
	const currentPage = urlParams.get('page') ? urlParams.get('page') : 1;
	const { currentLang } = useStore((state) => state.currentLang);
	const companyName = urlParams.get('companyName') ? urlParams.get('companyName') : null;
	const subject = urlParams.get('subject') ? urlParams.get('subject') : null;
	const number = urlParams.get('number') ? urlParams.get('number') : null;
	const department = urlParams.get('department') ? urlParams.get('department') : null;
	const office = urlParams.get('office') ? urlParams.get('office') : null;
	const status = urlParams.get('status') ? urlParams.get('status') : null;
	const fromDate = urlParams.get('fromDate') ? urlParams.get('fromDate') : null;
	const toDate = urlParams.get('toDate') ? urlParams.get('toDate') : null;
	const read = urlParams.get('read') ? urlParams.get('read') : null;
	const showSpam = urlParams.get('showSpam') ? urlParams.get('showSpam') : null;
	const showNearlyDue = urlParams.get('showNearlyDue') ? urlParams.get('showNearlyDue') : null;
	const type = urlParams.get('type') ? urlParams.get('type') : null;
	const showIncomplete = urlParams.get('showIncomplete') ? urlParams.get('showIncomplete') : null;
	const { currentUser } = useStore((state) => state.currentUser);
	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');
	const [loadProposals, { loading, data }] = useLazyQuery(QUERY_PROPOSALS);
	const [loadPublicServices, { data: dataPublicServices }] = useLazyQuery(QUERY_ALL_PUBLIC_SERVICES);
	const [rowLimit, setRowLimit] = useState(10);
	const [excelData, setExcelData] = useState(null);
	const [openDownloadExcel, setOpenDownloadExcel] = useState(null);
	const [viewingId, setViewingId] = useState(null);
	const [openDetailModal, setOpenDetailModal] = useState(false);
	const { isOpen, onOpen, onClose } = useDisclosure();
	useEffect(() => {
		window.scrollTo(0, 0);
		loadProposals({
			variables: {
				companyName,
				subject,
				number: parseInt(number),
				department,
				office,
				offset: currentPage ? (currentPage - 1) * rowLimit : 0,
				fromDate: datePickerFromToToDate(fromDate),
				toDate: datePickerFromToToDate(toDate),
				read: read === 'false' ? false : read === 'true' ? true : null,
				type,
				status: status !== null ? (status === 'all' ? null : status) : 'in progress',
				limit: rowLimit,
				showIncomplete: showIncomplete === 'true' ? true : null,
				auditServiceOnly,
			},
		});
		loadPublicServices();
	}, []);

	const [openFilter, setOpenFilter] = useState(false);

	function handlePageClick(data) {
		let selected = data.selected;
		const page = selected + 1;

		let url = `?page=${page}`;

		if (number) {
			url += `&number=${number}`;
		}

		if (companyName) {
			url += `&companyName=${companyName}`;
		}

		if (subject) {
			url += `&subject=${subject}`;
		}

		if (department) {
			url += `&department=${department}`;
		}

		if (office) {
			url += `&office=${office}`;
		}

		if (status) {
			url += `&status=${status}`;
		}

		if (fromDate) {
			url += `&fromDate=${fromDate}`;
		}

		if (toDate) {
			url += `&toDate=${toDate}`;
		}

		if (type) {
			url += `&type=${type}`;
		}

		if (read !== null) {
			const unreadOnly = read ? read : '';
			if (unreadOnly) {
				url += `&read=false`;
			}
		}

		if (showSpam) {
			url += `&showSpam=${showSpam}`;
		}

		if (showNearlyDue) {
			url += `&showNearlyDue=${showNearlyDue}`;
		}

		if (showIncomplete) {
			url += `&showIncomplete=${showIncomplete}`;
		}

		if (auditServiceOnly) {
			history.push(`/audit-company${url}`);
		} else {
			history.push(`/company-submission-proposal${url}`);
		}
	}

	function handleStatusChange(statusValue) {
		const page = 1;

		let url = `?page=${page}`;

		if (statusValue) {
			url += `&status=${statusValue}`;
		}

		if (number) {
			url += `&number=${number}`;
		}

		if (companyName) {
			url += `&companyName=${companyName}`;
		}

		if (subject) {
			url += `&subject=${subject}`;
		}

		if (department) {
			url += `&department=${department}`;
		}

		if (office) {
			url += `&office=${office}`;
		}

		if (fromDate) {
			url += `&fromDate=${fromDate}`;
		}

		if (toDate) {
			url += `&toDate=${toDate}`;
		}

		if (type) {
			url += `&type=${type}`;
		}

		if (read !== null) {
			const unreadOnly = read ? read : '';
			if (unreadOnly) {
				url += `&read=false`;
			}
		}

		if (showSpam) {
			url += `&showSpam=${showSpam}`;
		}

		if (showNearlyDue) {
			url += `&showNearlyDue=${showNearlyDue}`;
		}

		if (showIncomplete) {
			url += `&showIncomplete=${showIncomplete}`;
		}

		if (auditServiceOnly) {
			history.push(`/audit-company${url}`);
		} else {
			history.push(`/company-submission-proposal${url}`);
		}
	}

	useEffect(() => {
		if (currentPage) {
			window.scrollTo(0, 0);
			loadProposals({
				variables: {
					number: parseInt(number),
					companyName,
					subject,
					department,
					office,
					offset: currentPage ? (currentPage - 1) * rowLimit : 0,
					fromDate: datePickerFromToToDate(fromDate),
					toDate: datePickerFromToToDate(toDate),
					read: read === 'false' ? false : read === 'true' ? true : null,
					publicService: type !== null ? (type === 'all' ? null : type === 'PUBLIC_SERVICE' ? true : false) : null,
					status: status !== null ? (status === 'all' ? null : status) : 'in progress',
					spam: showSpam === 'true' ? true : null,
					showNearlyDue: showNearlyDue === 'true' ? true : null,
					limit: rowLimit,
					showIncomplete: showIncomplete === 'true' ? true : null,
					auditServiceOnly,
				},
			});
		}
	}, [
		rowLimit,
		currentPage,
		fromDate,
		toDate,
		read,
		number,
		companyName,
		subject,
		department,
		office,
		type,
		status,
		showSpam,
		showNearlyDue,
		showIncomplete,
	]);

	function callbackFilter(e) {
		if (auditServiceOnly) {
			history.push(`/audit-company${e}`);
		} else {
			history.push(`/company-submission-proposal${e}`);
		}
	}

	function checkRead(item) {
		let read = false;
		if (currentUser?.role === 'admin') {
			read = item?.read;
		} else {
			item?.assignTo?.forEach((aTo) => {
				if (aTo?.user?.id === currentUser?.id) {
					read = aTo?.read;
				}
			});
		}
		return read;
	}

	function getStatus({ done, doneDate }) {
		return done === false ? (
			<Badge colorScheme="yellow">{t('In progress')}</Badge>
		) : (
			<Tooltip label={doneDate ? moment(doneDate).format('LLLL') : ''}>
				<Badge colorScheme="green">{t('Done')}</Badge>
			</Tooltip>
		);
	}

	function getProposalType(publicService) {
		return publicService ? <Badge colorScheme="green">{t('Public Service')}</Badge> : <Badge colorScheme="yellow">{t('Other')}</Badge>;
	}

	function getDisplayCompanyName(item) {
		let displayName = item?.companyName;
		if (item?.company?.id) {
			if (currentLang === 'kh') {
				displayName = item?.company?.nameKhmer;
			} else {
				displayName = item?.company?.name;
			}
		}
		return displayName;
	}

	function panelTabs({ name, value }) {
		let active = status ? status : 'in progress';

		return (
			<Flex
				className="panel-tab"
				userSelect="none"
				minW="100px"
				onClick={() => handleStatusChange(value)}
				cursor="pointer"
				mb={'-2px'}
				_hover={{ boxShadow: `inset 0 -2px 0 0 ${value === active ? '#2980b9' : '#bdc3c7'}` }}
				boxShadow={value === active ? 'inset 0 -2px 0 0 #2980b9' : ''}
				pt="16px"
				pb="16px"
				pl="12px"
				pr="12px"
				alignItems="center"
				justifyContent="center"
			>
				<Text fontWeight={value === active ? '700' : '500'}>{t(name)}</Text>
			</Flex>
		);
	}

	function generateExcelData() {
		const tmp = [];
		data?.getCompanySubmissionProposals?.companySubmissionProposals?.forEach((item, index) => {
			tmp.push({
				number: item?.no,
				companyName: getDisplayCompanyName(item),
				subject: item.subject,
				createdAt: moment(item.createdAt).format(c.excelDateTimeFormat),
				dueDate: item?.dueDate ? moment(item?.dueDate).format(c.excelDateOnlyFormat) : 'N/A',
				type: item?.publicService ? 'Public Service' : 'Other',
				publicServiceName: item?.publicService ? getPublicServiceByValue(item?.publicService) : null,
				status: item?.done === false ? 'In progress' : 'Done',
			});
		});
		setExcelData(tmp);
		setTimeout(() => {
			setOpenDownloadExcel(true);
		}, 100);
	}

	function getPublicServiceByValue(value) {
		let res = '';
		if (value) {
			let data = dataPublicServices?.getAllPublicServices?.filter((pb) => pb.value === value);
			res = data[0]?.title;
		}
		return res;
	}

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: auditServiceOnly ? 'AUDIT COMPANY' : 'PROPOSAL',
								path: '#',
							},
						]}
					/>
					<Center className="show-only-printing">
						<Text textAlign="center" color="#62B3ED" fontFamily="Moul" fontSize={18}>
							ការស្នើសុំ
						</Text>
					</Center>
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb="32px"
						>
							<Flex
								className="hidden-print responsive-header-for-table"
								bg="#FAFAFA"
								p="16px"
								pt="0"
								pb="0"
								mb="16px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Flex className="panel-tab-container" minW="303px">
									{panelTabs({ name: 'In progress', value: 'in progress' })}
									{panelTabs({ name: 'Done', value: 'done' })}
									{panelTabs({ name: 'All', value: 'all' })}
								</Flex>

								<Box className="mobile-header-menu" mt="2px" w="100%" display="none">
									<Accordion w="100%" allowMultiple>
										<AccordionItem>
											<h2>
												<AccordionButton>
													<Box as="span" flex="1" textAlign="left" fontWeight="bold">
														{t('Menu')}
													</Box>
													<AccordionIcon />
												</AccordionButton>
											</h2>
											<AccordionPanel p={4}>
												<SimpleGrid columns={[2, null, 3]} spacingX={4} spacingY={4}>
													{(currentUser?.username === 'admin' || currentUser?.canAutoreassignProposal) && (
														<Button
															width="100%"
															isDisabled={data?.getCompanySubmissionProposals?.companySubmissionProposals?.length === 0}
															leftIcon={<FontAwesomeIcon icon={faRetweet} style={{ fontSize: 16 }} />}
															colorScheme="gray"
															variant="solid"
															size="sm"
															borderRadius={c.borderRadius}
															border="1px solid #bdc3c7"
															onClick={onOpen}
														>
															{t('Reassign')}
														</Button>
													)}
													{currentUser?.canViewListReportToCompanyProposal && false === auditServiceOnly && (
														<Link to={'/company-submission-proposal-list-report'}>
															<Button
																width="100%"
																leftIcon={<FontAwesomeIcon icon={faChartLine} style={{ fontSize: 16 }} />}
																colorScheme="gray"
																variant="solid"
																size="sm"
																borderRadius={c.borderRadius}
																border="1px solid #bdc3c7"
															>
																{t('List Report')}
															</Button>
														</Link>
													)}
													<Button
														width="100%"
														onClick={() => generateExcelData()}
														leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
														colorScheme="gray"
														variant="solid"
														size="sm"
														borderRadius={c.borderRadius}
														border="1px solid #bdc3c7"
													>
														{t('Export')}
													</Button>
													<Button
														width="100%"
														onClick={() => window?.print()}
														leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
														colorScheme="gray"
														variant="solid"
														size="sm"
														borderRadius={c.borderRadius}
														border="1px solid #bdc3c7"
													>
														{t('Print')}
													</Button>
													{false === auditServiceOnly && (
														<Link to={'/company-submission-proposal/add'}>
															<Button
																width="100%"
																leftIcon={<FontAwesomeIcon icon={faPlus} style={{ fontSize: 16 }} />}
																colorScheme="gray"
																variant="solid"
																size="sm"
																borderRadius={c.borderRadius}
																border="1px solid #bdc3c7"
															>
																{t('Add')}
															</Button>
														</Link>
													)}
													<Button
														width="100%"
														onClick={() => setOpenFilter(true)}
														leftIcon={<FontAwesomeIcon icon={faSlidersH} style={{ fontSize: 16 }} />}
														colorScheme={`${
															number ||
															companyName ||
															subject ||
															department ||
															office ||
															fromDate ||
															toDate ||
															read ||
															type ||
															showSpam ||
															showNearlyDue ||
															showIncomplete
																? 'yellow'
																: 'gray'
														}`}
														variant="solid"
														size="sm"
														borderRadius={c.borderRadius}
														border="1px solid #bdc3c7}"
													>
														{t('Filter')}
													</Button>
												</SimpleGrid>
											</AccordionPanel>
										</AccordionItem>
									</Accordion>
								</Box>

								<Flex className="header-menu" alignItems="center" justifyContent="flex-end" minW="361px">
									{(currentUser?.username === 'admin' || currentUser?.canAutoreassignProposal) && (
										<>
											<Button
												mr="2"
												isDisabled={data?.getCompanySubmissionProposals?.companySubmissionProposals?.length === 0}
												leftIcon={<FontAwesomeIcon icon={faRetweet} style={{ fontSize: 16 }} />}
												colorScheme="gray"
												variant="solid"
												size="sm"
												borderRadius={c.borderRadius}
												border="1px solid #bdc3c7"
												onClick={onOpen}
											>
												{t('Reassign')}
											</Button>
										</>
									)}
									{currentUser?.canViewListReportToCompanyProposal && false === auditServiceOnly && (
										<Link to={'/company-submission-proposal-list-report'}>
											<Button
												mr="2"
												leftIcon={<FontAwesomeIcon icon={faChartLine} style={{ fontSize: 16 }} />}
												colorScheme="gray"
												variant="solid"
												size="sm"
												borderRadius={c.borderRadius}
												border="1px solid #bdc3c7"
											>
												{t('List Report')}
											</Button>
										</Link>
									)}
									<Button
										mr="2"
										onClick={() => generateExcelData()}
										leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
										colorScheme="gray"
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7"
									>
										{t('Export')}
									</Button>
									<Button
										mr="2"
										onClick={() => window?.print()}
										leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
										colorScheme="gray"
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7"
									>
										{t('Print')}
									</Button>
									{false === auditServiceOnly && (
										<Link to={'/company-submission-proposal/add'}>
											<Button
												mr="2"
												leftIcon={<FontAwesomeIcon icon={faPlus} style={{ fontSize: 16 }} />}
												colorScheme="gray"
												variant="solid"
												size="sm"
												borderRadius={c.borderRadius}
												border="1px solid #bdc3c7"
											>
												{t('Add')}
											</Button>
										</Link>
									)}
									<Button
										onClick={() => setOpenFilter(true)}
										leftIcon={<FontAwesomeIcon icon={faSlidersH} style={{ fontSize: 16 }} />}
										colorScheme={`${
											number ||
											companyName ||
											department ||
											subject ||
											office ||
											fromDate ||
											toDate ||
											read ||
											type ||
											showSpam ||
											showNearlyDue ||
											showIncomplete
												? 'yellow'
												: 'gray'
										}`}
										variant="solid"
										size="sm"
										borderRadius={c.borderRadius}
										border="1px solid #bdc3c7}"
									>
										{t('Filter')}
									</Button>
								</Flex>
							</Flex>
							<Box p="16px" pt="0">
								<Table variant="simple" className="table-company-proposal-list responsive-table-container">
									<Thead>
										<Tr className="td-as-th">
											<Th align="left">{t('Number')}</Th>
											<Th align="left">{t('Company/Institution Name')}</Th>
											<Th align="left">{t('Subject')}</Th>
											<Th align="left">{t('Proposal Created At')}</Th>
											<Th align="left">{t('Due Date')}</Th>
											<Th align="right">{t('Type')}</Th>
											<Th align="right">{t('Status')}</Th>
										</Tr>
									</Thead>
									<Tbody>
										{loading && <LoadingResponsiveTable column={7} />}
										{data?.getCompanySubmissionProposals?.companySubmissionProposals?.length <= 0 && (
											<Tr>
												<center>
													<Text>{t('No Data')}</Text>
												</center>
											</Tr>
										)}
										{data?.getCompanySubmissionProposals?.companySubmissionProposals?.map((item, index) => {
											return (
												<Tr
													className={checkRead(item) ? 'read' : 'new'}
													cursor="pointer"
													key={`item-${index}`}
													_hover={{ bg: 'gray.200' }}
												>
													<Td
														className="zoom-td"
														onClick={() => {
															setViewingId(item?.id);
															setOpenDetailModal(true);
														}}
													>
														{item?.no}
													</Td>
													<Td
														onClick={() => {
															if (auditServiceOnly) {
																history.push(`/audit-company/detail?id=${item.id}`);
															} else {
																history.push(`/company-submission-proposal/detail?id=${item.id}`);
															}
														}}
													>
														<Text fontWeight="500" maxW="400px" noOfLines={4}>
															{getDisplayCompanyName(item)}
														</Text>
													</Td>
													<Td
														onClick={() => {
															if (auditServiceOnly) {
																history.push(`/audit-company/detail?id=${item.id}`);
															} else {
																history.push(`/company-submission-proposal/detail?id=${item.id}`);
															}
														}}
													>
														<Tooltip label={item?.subject}>
															<Text fontWeight="500" maxW="400px" noOfLines={[6, 6, 4, 4, 4]}>
																{item?.subject}
															</Text>
														</Tooltip>
													</Td>
													<Td
														onClick={() => {
															if (auditServiceOnly) {
																history.push(`/audit-company/detail?id=${item.id}`);
															} else {
																history.push(`/company-submission-proposal/detail?id=${item.id}`);
															}
														}}
													>
														{moment(item?.startServiceDate ? item?.startServiceDate : item.createdAt).format('LLLL')}
													</Td>
													<Td
														onClick={() => {
															if (auditServiceOnly) {
																history.push(`/audit-company/detail?id=${item.id}`);
															} else {
																history.push(`/company-submission-proposal/detail?id=${item.id}`);
															}
														}}
													>
														{item?.dueDate ? moment(item?.dueDate).format(c.dateTextOnlyFormat) : 'N/A'}
													</Td>
													<Td
														onClick={() => {
															if (auditServiceOnly) {
																history.push(`/audit-company/detail?id=${item.id}`);
															} else {
																history.push(`/company-submission-proposal/detail?id=${item.id}`);
															}
														}}
													>
														<Flex justifyContent="flex-end">
															{getProposalType(item.publicService)}
															{item.spam === true && (
																<Badge ml={2} colorScheme="red">
																	{t('Spam')}
																</Badge>
															)}
														</Flex>
													</Td>
													<Td
														onClick={() => {
															if (auditServiceOnly) {
																history.push(`/audit-company/detail?id=${item.id}`);
															} else {
																history.push(`/company-submission-proposal/detail?id=${item.id}`);
															}
														}}
													>
														<Flex justifyContent="flex-end">
															{item?.submissionStatus === '1' ? (
																getStatus({ done: item?.done, doneDate: item?.doneAt })
															) : (
																<>
																	{item?.submissionStatus === '2' && (
																		<Badge colorScheme="purple">{t('PENDING PAYMENT')}</Badge>
																	)}
																	{item?.submissionStatus === '3' && <Badge colorScheme="red">{t('CANCEL')}</Badge>}
																</>
															)}
														</Flex>
													</Td>
												</Tr>
											);
										})}
									</Tbody>
									<tfoot className="responsive-footer">
										<Tr className="td-as-th">
											<Th align="left">{t('Number')}</Th>
											<Th align="left">{t('Company/Institution Name')}</Th>
											<Th align="left">{t('Subject')}</Th>
											<Th align="left">{t('Proposal Created At')}</Th>
											<Th align="left">{t('Due Date')}</Th>
											<Th align="right">{t('Type')}</Th>
											<Th align="right">{t('Status')}</Th>
										</Tr>
									</tfoot>
								</Table>
								<Flex justifyContent="flex-start" className="show-only-printing">
									{t('Total Rows')}: {data?.getCompanySubmissionProposals?.totalRows}
								</Flex>
								<Flex justifyContent="flex-end" className="hidden-print">
									{t('Total Rows')}: {data?.getCompanySubmissionProposals?.totalRows}
								</Flex>
								{data?.getCompanySubmissionProposals?.totalPages > 1 && (
									<Flex className="hidden-print" justifyContent="flex-end" w="100%" mt="4">
										<ReactPaginate
											previousLabel={<ChevronLeftIcon fontSize="20px" />}
											nextLabel={<ChevronRightIcon fontSize="20px" />}
											breakLabel={'...'}
											breakClassName={'break-me'}
											disableInitialCallback={true}
											pageCount={data?.getCompanySubmissionProposals?.totalPages}
											marginPagesDisplayed={1}
											pageRangeDisplayed={1}
											onPageChange={handlePageClick}
											containerClassName={'pagination'}
											activeClassName={'active'}
											initialPage={(currentPage - 1) | 0}
										/>
									</Flex>
								)}
								<Flex className="hidden-print" justifyContent="flex-end" mt="6">
									<Text mr="2">{t('Show more rows')}</Text>
									<Checkbox
										isChecked={rowLimit > 10}
										onChange={() => {
											handlePageClick({ selected: 0 });
											if (rowLimit > 10) {
												setRowLimit(10);
											} else {
												setRowLimit(300);
											}
										}}
									></Checkbox>
								</Flex>
							</Box>
						</Box>
					</Center>
				</Container>
				<CompanySubmissionProposalFilter
					callback={callbackFilter}
					isOpen={openFilter}
					onClose={() => setOpenFilter(false)}
					fromDate={fromDate}
					toDate={toDate}
					read={read}
					number={number}
					companyName={companyName}
					subject={subject}
					department={department}
					office={office}
					type={type}
					status={status}
					showSpam={showSpam === 'true' ? true : false}
					showNearlyDue={showNearlyDue === 'true' ? true : false}
					showIncomplete={showIncomplete === 'true' ? true : false}
					auditServiceOnly={auditServiceOnly}
				/>

				{openDownloadExcel && <ExcelExportModal title="Proposal" isOpen={true} onClose={() => setOpenDownloadExcel(false)} data={excelData} />}

				{openDetailModal && viewingId && (
					<ProposalDetailModal id={viewingId} onCloseModal={() => setOpenDetailModal(false)} auditServiceOnly={auditServiceOnly} />
				)}

				{loading && <LoadingOverlayText />}

				{isOpen && (
					<ProposalReassignModal proposals={data?.getCompanySubmissionProposals?.companySubmissionProposals} isOpen={isOpen} onClose={onClose} />
				)}
			</>
		</PrintLayout>
	);
}

export default Proposal;
